<template>
    <app-modal-view @close="closeModal">
        <template #header>
            <slot name="header-title">
                <p class="is-size-5 has-text-weight-bold has-text-centered">
                    {{ $t('Community.welcome_title') }} {{ community.title }}
                </p>
            </slot>
        </template>
        <template #body>
            <div style="width: 100%">
                <div
                    style="
                        position: relative;
                        padding-bottom: 56.25%;
                        padding-top: 0;
                        height: 0;
                    "
                >
                    <iframe
                        :src="community.presentationUrl"
                        frameborder="0"
                        style="
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                        "
                        type="text/html"
                        allowscriptaccess="always"
                        allowfullscreen="true"
                        scrolling="yes"
                        allownetworking="all"
                    ></iframe>
                </div>
            </div>
        </template>
        <template #footer>
            <div
                class="is-flex is-justify-content-space-between"
                style="width: 100%"
            >
                <label class="checkbox">
                    <input v-model="dismissWelcome" type="checkbox" />
                    {{ $t('Buttons.do_not_show_again') }}
                </label>
                <button
                    v-t="'Buttons.close'"
                    class="button is-dark"
                    @click="closeModal"
                ></button>
            </div>
        </template>
    </app-modal-view>
</template>

<script>
import AppModalView from '@/components/AppModalView';
export default {
    components: {
        AppModalView,
    },
    data() {
        console.log(
            'ckecking for cookie',
            'community.dismiss_show_welcome_' + this.$route.params.communityId,
            this.$cookies.isKey(
                'community.dismiss_show_welcome_' +
                    this.$route.params.communityId
            )
        );
        return {
            dismissWelcome: this.$cookies.isKey(
                'community.dismiss_show_welcome_' +
                    this.$route.params.communityId
            ),
        };
    },
    computed: {
        community() {
            return this.$store.getters.community;
        },
    },
    methods: {
        closeModal() {
            if (this.dismissWelcome) {
                console.log(
                    'dismissing welcome',
                    'community.dismiss_show_welcome_' + this.community._id
                );
                this.$cookies.set(
                    'community.dismiss_show_welcome_' + this.community._id,
                    true,
                    Infinity,
                    null,
                    null,
                    true,
                    'None'
                );
                console.log(
                    'dismissing welcome',
                    this.$cookies.isKey(
                        'community.dismiss_show_welcome_' +
                            this.$route.params.communityId
                    )
                );
            }
            this.$emit('close');
        },
    },
};
</script>

<style></style>
